import React from "react";
import Work from "@material-ui/icons/Work";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import styles from "./styles";
import Icon from "../../../components/Icon";

export const ActionsSection = () => {
  const classes = styles();
  return (
    <div>
      <ul className={classes.breadcrumbsStyle}>
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#">Como usar mi plan</a>
        </li>
        <li>
          <a href="#">Plan Escencial 3D </a>
        </li>
      </ul>
    </div>
  );
};
